<template>
  <el-dialog
    :title="$t('paymentPool.add')"
    :visible.sync="dialogVisible"
    width="70%"
    @close="closeDialog"
  >
    <el-form ref="form" :model="addPaymentPoolInfo" label-width="120px">
      <el-form-item :label="$t('paymentPool.name')" prop="paymentName" required>
        <el-input
          v-model="addPaymentPoolInfo.paymentName"
          :placeholder="$t('paymentPool.requiredName')"
        />
      </el-form-item>
      
      <el-form-item :label="$t('paymentPool.paymentVendor')" prop="paymentType" required>
        <el-select
          v-model="addPaymentPoolInfo.paymentType"
          :placeholder="$t('paymentPool.requiredPaymentVendor')"
          style="width:100%"
          @change="_addChangeToType"
        >
          <el-option
            v-for="(item,index) in addPaymentPoolInfo.paymentTypes"
            :key="index"
            :label="item.name"
            :value="item.paymentType"
          />
        </el-select>
      </el-form-item>

      <el-form-item
        v-for="(item,index) in addPaymentPoolInfo.paymentKeys"
        :key="index"
        :label="item.name"
      >
        <el-input
          v-model="item.columnValue"
          type="textarea"
          :placeholder="item.remark"
        />
      </el-form-item>

      <el-form-item
        v-if="addPaymentPoolInfo.paymentType === 'WECHAT'"
        :label="$t('paymentPool.merchantCert')"
      >
        <upload-file
          ref="uploadFile"
          @notifyCert="handleCertUpload"
        />
      </el-form-item>

      <el-form-item :label="$t('paymentPool.paymentScope')" prop="payType" required>
        <el-select
          v-model="addPaymentPoolInfo.payType"
          :placeholder="$t('paymentPool.requiredPaymentScope')"
          style="width:100%"
        >
          <el-option
            label="店铺费用"
            value="1001"
          />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('paymentPool.usageInstructions')">
        <el-input
          v-model="addPaymentPoolInfo.remark"
          type="textarea"
          :placeholder="$t('paymentPool.optionalInstructions')"
        />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="savePaymentPoolInfo">{{ $t('common.save') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { savePaymentPool, listPaymentKey, listPaymentAdapt } from '@/api/frame/paymentPool/paymentPoolApi'
import { getShopId } from '@/api/shop/shopApi'
import UploadFile from '@/components/frame/uploadFile/uploadFile.vue'

export default {
  name: 'AddPaymentPool',
  components: {
    UploadFile
  },
  data() {
    return {
      dialogVisible: false,
      addPaymentPoolInfo: {
        paymentName: '',
        paymentType: '',
        certPath: '',
        state: 'Y',
        remark: '',
        paymentTypes: [],
        paymentKeys: [],
        payType: '1001',
        feeConfigs: [],
        configIds: []
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this._loadAddPaymentAdapt()
    },
    closeDialog() {
      this.dialogVisible = false
      this.resetForm()
    },
    resetForm() {
      this.addPaymentPoolInfo = {
        paymentName: '',
        paymentType: '',
        certPath: '',
        state: 'Y',
        remark: '',
        paymentTypes: this.addPaymentPoolInfo.paymentTypes,
        paymentKeys: [],
        payType: '1001',
        feeConfigs: [],
        configIds: []
      }
      this.$refs.uploadFile && this.$refs.uploadFile.clear()
    },
    async _loadAddPaymentAdapt() {
      try {
        const res = await listPaymentAdapt({ page: 1, row: 100 })
        this.addPaymentPoolInfo.paymentTypes = res.data
      } catch (error) {
        console.error('获取支付类型失败:', error)
      }
    },
    async _addChangeToType() {
      if (!this.addPaymentPoolInfo.paymentType) return
      
      try {
        const res = await listPaymentKey({
          paymentType: this.addPaymentPoolInfo.paymentType,
          page: 1,
          row: 100
        })
        this.addPaymentPoolInfo.paymentKeys = res.data.map(item => ({
          ...item,
          columnValue: ''
        }))
      } catch (error) {
        console.error('获取支付密钥失败:', error)
      }
    },
    handleCertUpload(fileInfo) {
      this.addPaymentPoolInfo.certPath = fileInfo.realFileName
    },
    async savePaymentPoolInfo() {
      try {
        this.addPaymentPoolInfo.shopId = getShopId()
        await savePaymentPool(this.addPaymentPoolInfo)
        this.$message.success(this.$t('paymentPool.saveSuccess'))
        this.$emit('refresh')
        this.closeDialog()
      } catch (error) {
        console.error('保存支付配置失败:', error)
      }
    }
  }
}
</script>